import {
  AuthAction,
  LOAD_AUTH_USER,
  LOAD_AUTH_USER_SUCCESS,
  LOAD_AUTH_USER_FAIL,
  LOGIN,
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  LOGOUT,
  LOGOUT_FAIL,
  LOGOUT_SUCCESS,
  LOGIN_KEYCLOAK,
  LOGOUT_KEYCLOAK
} from "./actionTypes";

interface AuthState {
  /**
   * TODO: All of these have been marked as optional as it's not clear what is
   * and isn't used or required in the application. This should be updated as we
   * go.
   */
  user: {
    token?: string;
    username?: string;
    email?: string;
    display_name?: string;
    status?: string;
    access?: string[];
    role?: Insite.Role;
    rolesRestriction?: Insite.Role[];
    responsibility_group?: string[];
    /** The project or site groups that the user belongs to */
    groups?: string[];
    /** Used internally to identify and track the types of users in analytics */
    role_tracking?: string;
    project?: string[];
    portfolio?: {
      /** The projects that a user has access to, indexed by their ID */
      projects: {
        [key: number]: Insite.Project;
      };
      /** The sites that the user has access to, indexed by their ID */
      sites: {
        [key: string]: Insite.Site;
      };
    };

    // TODO: These are never used?
    /** When the user was initially created */
    createdat?: string;
    /** The last time the user was updated */
    updatedat?: string;
  };
  loading?: boolean;
  loaded?: boolean;
  loggingIn?: boolean;
  loggingOut?: boolean;
  loginError?: string;
  logoutError?: string;
  /**
   * TODO: This is really permissive, we seem to manage errors slightly
   * different ways in a few places.
   */
  error?:
    | null
    | string
    | Error
    | {
        error: Error;
        message: string;
      };
}

const INITIAL_USER_STATE = {
  token: undefined,
  access: [],
};

/**
 * gets the initial state, conditionally prepopulating
 * with mock values if app is running in the context
 * of a Cypress test
 */
function getInitialState(defaultUser: typeof INITIAL_USER_STATE): AuthState {
  const e2eUser = window.Cypress && window.Cypress.env("user");
  const user = e2eUser || defaultUser;

  return {
    user,
    loading: false,
    loaded: false,
    loggingIn: false,
    loggingOut: false,
  };
}

const INITIAL_STATE = getInitialState(INITIAL_USER_STATE);

export function reducer(state = INITIAL_STATE, action: AuthAction): AuthState {
  switch (action.type) {
    case LOAD_AUTH_USER:
      return {
        ...state,
        loading: true,
      };
    case LOAD_AUTH_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        user: { ...state.user, ...action.result },
      };
    case LOAD_AUTH_USER_FAIL:
      return {
        ...INITIAL_STATE,
        loading: false,
        loaded: false,
        error: action.error,
      };
    case LOGIN:
      return {
        ...state,
        // TODO: Why is this the way that it is?
        user: { username: action.username },
        loggingIn: true,
        loginError: undefined,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loggingIn: false,
        user: {
          ...state.user,
          token: action.result.token,
        },
      };

    case LOGIN_FAIL:
      return {
        ...state,
        loggingIn: false,
        user: INITIAL_USER_STATE,
        loginError: action.error.error || "Invalid username/password",
      };

    case LOGIN_KEYCLOAK:
      return {
        ...state,
        loggingIn: false,
        loginError: undefined,
        user: {
          ...state.user,
          username: action.username,
          token: action.token,
        },
      };

case LOGOUT_KEYCLOAK:
  return {
    ...state,
    loading: false,
    loaded: false,
    loggingOut: false,
    user: INITIAL_USER_STATE,
  };
    case LOGOUT:
      return {
        ...state,
        loading: false,
        loaded: false,
        loggingOut: true,
        user: INITIAL_USER_STATE,
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        loggingOut: false,
      };
    case LOGOUT_FAIL:
      return {
        ...state,
        loggingOut: false,
        logoutError: action.error,
      };
    default:
      return state;
  }
}
